export const QyonLogo = () => {
  return (
    <svg
      width="274"
      height="90"
      viewBox="0 0 274 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4760_15505)">
        <path
          d="M256.721 2.4502V43.5898L242.59 24.6473L226.443 2.47642H209.664V6.70867V7.90041V70.8758H226.443V30.6264L232.228 38.8738L256.721 70.8743V70.8758H256.724L256.729 70.8816L265.655 70.8758H273.5V70.8714V66.0783V2.47642V2.4502H256.721Z"
          fill="#0036B3"
        />
        <path
          d="M164.607 0C144.274 0 127.791 16.4832 127.791 36.8155C127.791 57.1478 144.274 73.631 164.607 73.631C184.939 73.631 201.422 57.1478 201.422 36.8155C201.422 16.4832 184.939 0 164.607 0ZM164.607 56.8812C153.525 56.8812 144.542 47.8966 144.542 36.8155C144.542 25.7344 153.525 16.7498 164.607 16.7498C175.688 16.7498 184.672 25.7344 184.672 36.8155C184.672 47.8966 175.689 56.8812 164.607 56.8812Z"
          fill="#0036B3"
        />
        <path
          d="M68.8396 60.6604L67.1613 58.357C71.5407 52.2993 74.1296 44.8619 74.1296 36.8155C74.1296 16.4847 57.6493 0.00145689 37.3184 0H37.3126C16.9818 0.00145689 0.5 16.4847 0.5 36.8155C0.5 57.1464 16.9832 73.631 37.3155 73.631C43.5131 73.631 49.3494 72.0926 54.4747 69.3871L58.4797 74.8869L68.8396 89.1134L79.1995 74.8869L68.8396 60.6604ZM37.3155 56.8812C26.2344 56.8812 17.2498 47.8966 17.2498 36.8155C17.2498 25.7344 26.2344 16.7498 37.3155 16.7498C48.3966 16.7498 57.3812 25.733 57.3812 36.8155C57.3812 39.1291 56.9849 41.3479 56.2652 43.4167H56.2477C54.2955 49.0155 49.9409 53.4736 44.4091 55.5671L44.4207 55.5831C42.2121 56.4194 39.8184 56.8827 37.3155 56.8827V56.8812Z"
          fill="#0036B3"
        />
        <path
          d="M109.329 36.7249L134.637 2.4502H113.548L100.946 19.4477L88.3457 2.4502H67.2559L92.7062 36.9463L92.7018 36.9551V70.8758H109.329V36.7249Z"
          fill="#0036B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_4760_15505">
          <rect
            width="273"
            height="89.1134"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BlueRectangle = () => {
  return (
    <svg
      width="295"
      height="24"
      viewBox="0 0 295 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="295" height="24" rx="12" fill="#0047EE" />
    </svg>
  );
};

export const PasswordIcon = () => {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.29057 3.34338C5.1646 1.79001 7.89024 0.113281 10.9998 0.113281C14.1094 0.113281 16.835 1.79001 18.709 3.34338C19.6602 4.13183 20.4275 4.91798 20.9574 5.50698C21.2229 5.80212 21.4303 6.04947 21.573 6.22514C21.6443 6.31302 21.6996 6.3831 21.7379 6.4324C21.757 6.45706 21.772 6.47654 21.7826 6.49046L21.7952 6.50715L21.7991 6.51228L21.8004 6.51403C21.8004 6.51403 21.8013 6.51524 20.9998 7.11328C21.8013 7.71133 21.8009 7.71186 21.8009 7.71186L21.7991 7.71428L21.7952 7.71942L21.7826 7.7361C21.772 7.75003 21.757 7.7695 21.7379 7.79416C21.6996 7.84347 21.6443 7.91354 21.573 8.00142C21.4303 8.17709 21.2229 8.42444 20.9574 8.71958C20.4275 9.30858 19.6602 10.0947 18.709 10.8832C16.835 12.4366 14.1094 14.1133 10.9998 14.1133C7.89024 14.1133 5.1646 12.4366 3.29057 10.8832C2.33937 10.0947 1.57208 9.30858 1.04221 8.71958C0.776696 8.42444 0.569273 8.17709 0.426639 8.00142C0.355286 7.91354 0.300038 7.84347 0.261732 7.79416C0.242577 7.7695 0.227647 7.75003 0.217049 7.7361L0.20441 7.71942L0.200549 7.71428L0.199237 7.71253C0.199237 7.71253 0.198339 7.71133 0.999802 7.11328C0.198339 6.51524 0.198736 6.5147 0.198736 6.5147L0.200549 6.51228L0.20441 6.50715L0.217049 6.49046C0.227647 6.47654 0.242577 6.45706 0.261732 6.4324C0.300038 6.3831 0.355286 6.31302 0.426639 6.22514C0.569273 6.04947 0.776696 5.80212 1.04221 5.50698C1.57208 4.91798 2.33937 4.13183 3.29057 3.34338ZM0.999802 7.11328L0.198736 6.5147C-0.0659804 6.86946 -0.0663776 7.35657 0.198339 7.71133L0.999802 7.11328ZM2.292 7.11328C2.36376 7.19624 2.44289 7.28616 2.52909 7.38198C3.01128 7.91798 3.70846 8.63183 4.5669 9.34338C6.31215 10.79 8.58651 12.1133 10.9998 12.1133C13.4131 12.1133 15.6875 10.79 17.4327 9.34338C18.2911 8.63183 18.9883 7.91798 19.4705 7.38198C19.5567 7.28616 19.6358 7.19624 19.7076 7.11328C19.6358 7.03032 19.5567 6.9404 19.4705 6.84458C18.9883 6.30858 18.2911 5.59474 17.4327 4.88318C15.6875 3.43656 13.4131 2.11328 10.9998 2.11328C8.58651 2.11328 6.31215 3.43656 4.5669 4.88318C3.70846 5.59474 3.01128 6.30858 2.52909 6.84458C2.44289 6.9404 2.36376 7.03032 2.292 7.11328ZM20.9998 7.11328L21.8009 7.71186C22.0656 7.3571 22.066 6.86999 21.8013 6.51524L20.9998 7.11328ZM7.4998 7.11328C7.4998 5.1803 9.06682 3.61328 10.9998 3.61328C12.9328 3.61328 14.4998 5.1803 14.4998 7.11328C14.4998 9.04627 12.9328 10.6133 10.9998 10.6133C9.06682 10.6133 7.4998 9.04627 7.4998 7.11328ZM10.9998 5.61328C10.1714 5.61328 9.4998 6.28487 9.4998 7.11328C9.4998 7.9417 10.1714 8.61328 10.9998 8.61328C11.8282 8.61328 12.4998 7.9417 12.4998 7.11328C12.4998 6.28487 11.8282 5.61328 10.9998 5.61328Z"
        fill="#7E899E"
      />
    </svg>
  );
};

export const DotRectangle = (props) => {
  return (
    <svg
      width={props?.width || 130}
      height={props?.height || 90}
      viewBox="0 0 175 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="3.01724"
        cy="3.01724"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="24.1383"
        cy="3.01724"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="45.2585"
        cy="3.01724"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="66.3795"
        cy="3.01724"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="87.4997"
        cy="3.01724"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="108.621"
        cy="3.01724"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="129.742"
        cy="3.01724"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="150.862"
        cy="3.01724"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="171.983"
        cy="3.01724"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="3.01724"
        cy="24.1383"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="24.1383"
        cy="24.1383"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="45.2585"
        cy="24.1383"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="66.3795"
        cy="24.1383"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="87.4997"
        cy="24.1383"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="108.621"
        cy="24.1383"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="129.742"
        cy="24.1383"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="150.862"
        cy="24.1383"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="171.983"
        cy="24.1383"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="3.01724"
        cy="45.2585"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="24.1383"
        cy="45.2585"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="45.2585"
        cy="45.2585"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="66.3795"
        cy="45.2585"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="87.4997"
        cy="45.2585"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="108.621"
        cy="45.2585"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="129.742"
        cy="45.2585"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="150.862"
        cy="45.2585"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="171.983"
        cy="45.2585"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="3.01724"
        cy="66.3795"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="24.1383"
        cy="66.3795"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="45.2585"
        cy="66.3795"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="66.3795"
        cy="66.3795"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="87.4997"
        cy="66.3795"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="108.621"
        cy="66.3795"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="129.742"
        cy="66.3795"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="150.862"
        cy="66.3795"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="171.983"
        cy="66.3795"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="3.01724"
        cy="87.4997"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="24.1383"
        cy="87.4997"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="45.2585"
        cy="87.4997"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="66.3795"
        cy="87.4997"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="87.4997"
        cy="87.4997"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="108.621"
        cy="87.4997"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="129.742"
        cy="87.4997"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="150.862"
        cy="87.4997"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="171.983"
        cy="87.4997"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="3.01724"
        cy="108.621"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="24.1383"
        cy="108.621"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="45.2585"
        cy="108.621"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="66.3795"
        cy="108.621"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="87.4997"
        cy="108.621"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="108.621"
        cy="108.621"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="129.742"
        cy="108.621"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="150.862"
        cy="108.621"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
      <circle
        cx="171.983"
        cy="108.621"
        r="3.01724"
        fill="#FCFCFC"
        fill-opacity="0.24"
      />
    </svg>
  );
};

export const LoginIcons = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 501 626"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_4575_34810)">
        <rect
          x="241"
          y="65.0771"
          width="63.7486"
          height="63.7486"
          rx="12.7497"
          transform="rotate(-45 241 65.0771)"
          fill="white"
        />
        <rect
          x="239.586"
          y="65.0771"
          width="65.7486"
          height="65.7486"
          rx="13.7497"
          transform="rotate(-45 239.586 65.0771)"
          stroke="#B2C9FF"
          stroke-width="2"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M271.585 62.1014C271.585 57.3337 275.45 53.4688 280.218 53.4688C282.538 53.4688 284.644 54.3849 286.194 55.8722C287.744 54.3849 289.85 53.4688 292.17 53.4688C296.938 53.4688 300.803 57.3337 300.803 62.1014C300.803 66.2638 298.365 70.0691 295.521 72.9406C292.665 75.8252 289.172 78.001 286.613 78.8514C286.341 78.9418 286.047 78.9418 285.775 78.8514C283.216 78.001 279.723 75.8252 276.867 72.9406C274.023 70.0691 271.585 66.2638 271.585 62.1014ZM280.218 56.1249C276.917 56.1249 274.241 58.8007 274.241 62.1014C274.241 65.2435 276.119 68.4106 278.754 71.0717C281.206 73.5482 284.118 75.3851 286.194 76.1806C288.27 75.3851 291.182 73.5482 293.634 71.0717C296.269 68.4106 298.147 65.2435 298.147 62.1014C298.147 58.8007 295.471 56.1249 292.17 56.1249C290.15 56.1249 288.364 57.126 287.28 58.6651C287.031 59.0184 286.626 59.2286 286.194 59.2286C285.762 59.2286 285.357 59.0184 285.108 58.6651C284.024 57.126 282.238 56.1249 280.218 56.1249Z"
        fill="url(#paint0_linear_4575_34810)"
      />
      <path
        d="M274.241 62.1014C274.241 58.8008 276.917 56.125 280.218 56.125C282.238 56.125 284.024 57.1261 285.108 58.6652C285.357 59.0185 285.762 59.2286 286.194 59.2286C286.626 59.2286 287.031 59.0185 287.28 58.6652C288.364 57.1261 290.15 56.125 292.171 56.125C295.471 56.125 298.147 58.8008 298.147 62.1014C298.147 65.2436 296.269 68.4107 293.634 71.0717C291.182 73.5482 288.27 75.3851 286.194 76.1807C284.118 75.3851 281.206 73.5482 278.754 71.0717C276.119 68.4107 274.241 65.2436 274.241 62.1014Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter1_dd_4575_34810)">
        <path
          d="M400.299 130.166C406.756 118.981 422.9 118.981 429.358 130.166L462.504 187.576C468.961 198.761 460.889 212.742 447.974 212.742H381.682C368.767 212.742 360.695 198.761 367.153 187.576L400.299 130.166Z"
          fill="white"
        />
        <path
          d="M430.497 129.508C423.533 117.446 406.123 117.446 399.159 129.508L366.013 186.918C359.049 198.98 367.754 214.058 381.682 214.058H447.974C461.902 214.058 470.607 198.98 463.643 186.918L430.497 129.508Z"
          stroke="#B2C9FF"
          stroke-width="2.63181"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M419.225 158.758C419.225 157.789 420.01 157.004 420.979 157.004H429.752C430.566 157.004 431.273 157.563 431.46 158.355C431.647 159.147 431.264 159.964 430.537 160.328L402.464 174.364C402.089 174.551 401.66 174.598 401.254 174.497L394.236 172.742C393.296 172.507 392.724 171.555 392.959 170.615C393.194 169.675 394.147 169.103 395.087 169.338L401.475 170.935L422.32 160.513H420.979C420.01 160.513 419.225 159.727 419.225 158.758ZM430.674 164.284C431.192 164.604 431.506 165.168 431.506 165.777V188.585C431.506 189.554 430.721 190.34 429.752 190.34H422.734C421.765 190.34 420.979 189.554 420.979 188.585V169.286C420.979 168.621 421.355 168.013 421.949 167.716L428.967 164.207C429.511 163.935 430.157 163.964 430.674 164.284ZM424.488 170.37V186.831H427.997V168.615L424.488 170.37ZM416.638 171.302C417.155 171.622 417.47 172.187 417.47 172.795V188.585C417.47 189.554 416.685 190.34 415.716 190.34H408.698C407.728 190.34 406.943 189.554 406.943 188.585V176.304C406.943 175.639 407.318 175.032 407.913 174.734L414.931 171.225C415.475 170.953 416.121 170.982 416.638 171.302ZM410.452 177.388V186.831H413.961V175.634L410.452 177.388ZM393.581 176.675C394.007 176.343 394.563 176.225 395.087 176.356L402.105 178.111C402.886 178.306 403.434 179.008 403.434 179.813V188.585C403.434 189.554 402.648 190.34 401.679 190.34H394.661C393.692 190.34 392.907 189.554 392.907 188.585V178.058C392.907 177.518 393.156 177.008 393.581 176.675ZM396.416 180.305V186.831H399.925V181.183L396.416 180.305ZM392.907 193.849C392.907 192.88 393.692 192.094 394.661 192.094H429.752C430.721 192.094 431.506 192.88 431.506 193.849C431.506 194.818 430.721 195.603 429.752 195.603H394.661C393.692 195.603 392.907 194.818 392.907 193.849Z"
        fill="url(#paint1_linear_4575_34810)"
      />
      <path
        d="M396.416 186.832V180.306L399.925 181.183V186.832H396.416Z"
        fill="#E7EEFE"
      />
      <path
        d="M410.452 186.832V177.389L413.961 175.634V186.832H410.452Z"
        fill="#E7EEFE"
      />
      <path
        d="M424.489 186.832V170.371L427.998 168.616V186.832H424.489Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter2_dd_4575_34810)">
        <rect
          x="276"
          y="395.077"
          width="63.7486"
          height="63.7486"
          rx="12.7497"
          transform="rotate(-45 276 395.077)"
          fill="white"
        />
        <rect
          x="274.586"
          y="395.077"
          width="65.7486"
          height="65.7486"
          rx="13.7497"
          transform="rotate(-45 274.586 395.077)"
          stroke="#B2C9FF"
          stroke-width="2"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M306.333 384.668C306.333 383.932 306.93 383.335 307.666 383.335H334.333C335.069 383.335 335.666 383.932 335.666 384.668V402.002C335.666 402.738 335.069 403.335 334.333 403.335H322.333V406.002H329C329.736 406.002 330.333 406.599 330.333 407.335C330.333 408.071 329.736 408.668 329 408.668H313C312.263 408.668 311.666 408.071 311.666 407.335C311.666 406.599 312.263 406.002 313 406.002H319.666V403.335H307.666C306.93 403.335 306.333 402.738 306.333 402.002V384.668ZM333 400.668V386.002H309V400.668H333ZM326.333 388.002C327.069 388.002 327.666 388.599 327.666 389.335V397.335C327.666 398.071 327.069 398.668 326.333 398.668C325.597 398.668 325 398.071 325 397.335V389.335C325 388.599 325.597 388.002 326.333 388.002ZM321 390.668C321.736 390.668 322.333 391.265 322.333 392.002V397.335C322.333 398.071 321.736 398.668 321 398.668C320.263 398.668 319.666 398.071 319.666 397.335V392.002C319.666 391.265 320.263 390.668 321 390.668ZM315.666 393.335C316.403 393.335 317 393.932 317 394.668V397.335C317 398.071 316.403 398.668 315.666 398.668C314.93 398.668 314.333 398.071 314.333 397.335V394.668C314.333 393.932 314.93 393.335 315.666 393.335Z"
        fill="url(#paint2_linear_4575_34810)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M333 386V400.667H309V386H333ZM326.333 388C327.07 388 327.667 388.597 327.667 389.333V397.333C327.667 398.07 327.07 398.667 326.333 398.667C325.597 398.667 325 398.07 325 397.333V389.333C325 388.597 325.597 388 326.333 388ZM321 390.667C321.736 390.667 322.333 391.264 322.333 392V397.333C322.333 398.07 321.736 398.667 321 398.667C320.264 398.667 319.667 398.07 319.667 397.333V392C319.667 391.264 320.264 390.667 321 390.667ZM315.667 393.333C316.403 393.333 317 393.93 317 394.667V397.333C317 398.07 316.403 398.667 315.667 398.667C314.93 398.667 314.333 398.07 314.333 397.333V394.667C314.333 393.93 314.93 393.333 315.667 393.333Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter3_d_4575_34810)">
        <rect
          x="114"
          y="528"
          width="63.7486"
          height="63.7486"
          rx="31.8743"
          fill="white"
        />
        <rect
          x="113"
          y="527"
          width="65.7486"
          height="65.7486"
          rx="32.8743"
          stroke="#B2C9FF"
          stroke-width="2"
        />
      </g>
      <path
        d="M147.041 561.211C147.163 561.212 147.281 561.213 147.396 561.214L148.039 561.226L148.602 561.246C148.69 561.25 148.775 561.255 148.857 561.26L149.322 561.297C150.05 561.369 150.562 561.496 151.093 561.716C152.726 562.393 154.024 563.691 154.7 565.324L154.751 565.449L154.842 565.695L154.92 565.942L154.955 566.069L155.016 566.332L155.066 566.615C155.074 566.664 155.081 566.715 155.088 566.767L155.124 567.095L155.153 567.463L155.174 567.878L155.195 568.607L155.207 569.817L155.208 571.875C155.208 572.612 154.611 573.209 153.875 573.209H137.875C137.138 573.209 136.541 572.611 136.541 571.875L136.542 569.755L136.547 569.021L136.558 568.378L136.579 567.814C136.583 567.727 136.588 567.642 136.593 567.559L136.63 567.095C136.702 566.367 136.829 565.855 137.049 565.324C137.725 563.691 139.023 562.393 140.657 561.716C141.187 561.496 141.699 561.369 142.427 561.297L142.892 561.26C143.057 561.25 143.232 561.241 143.419 561.235L144.021 561.219L144.709 561.211H147.041ZM136.641 562.518C136.952 563.127 136.749 563.863 136.193 564.233L136.059 564.311C135.306 564.695 134.694 565.307 134.311 566.059L134.269 566.144L134.194 566.319L134.129 566.509C134.109 566.575 134.09 566.645 134.073 566.72L134.025 566.96C134.018 567.002 134.011 567.046 134.005 567.092L133.969 567.387L133.94 567.729L133.917 568.123L133.9 568.578L133.88 569.695L133.876 570.372L133.875 571.875C133.875 572.612 133.278 573.209 132.541 573.209C131.858 573.209 131.294 572.694 131.217 572.031L131.208 571.875L131.209 570.29L131.219 569.185L131.231 568.552L131.251 567.991C131.255 567.904 131.259 567.819 131.264 567.736L131.296 567.269C131.369 566.391 131.502 565.824 131.738 565.268L131.864 564.99C131.887 564.943 131.91 564.896 131.935 564.849C132.574 563.594 133.594 562.574 134.848 561.935C135.504 561.601 136.307 561.862 136.641 562.518ZM156.901 561.935C158.156 562.574 159.175 563.594 159.815 564.849L159.941 565.109C159.961 565.152 159.98 565.195 159.998 565.237L160.102 565.496C160.118 565.54 160.133 565.583 160.148 565.628L160.232 565.9C160.244 565.947 160.257 565.994 160.268 566.042L160.333 566.343C160.353 566.447 160.371 566.556 160.387 566.671L160.431 567.033L160.466 567.436L160.504 568.13L160.527 568.953L160.538 569.928L160.541 571.875C160.541 572.612 159.944 573.209 159.208 573.209C158.524 573.209 157.961 572.694 157.884 572.031L157.875 571.875L157.873 570.372L157.861 569.099L157.841 568.342L157.822 567.919L157.796 567.552L157.763 567.235C157.757 567.185 157.751 567.138 157.745 567.092L157.701 566.836C157.677 566.716 157.651 566.609 157.62 566.509L157.555 566.319L157.48 566.144C157.467 566.115 157.453 566.087 157.439 566.059C157.098 565.39 156.576 564.832 155.936 564.447L155.69 564.311C155.034 563.977 154.773 563.174 155.108 562.518C155.442 561.862 156.245 561.601 156.901 561.935ZM146.997 563.877H144.755L143.876 563.889L143.395 563.905L142.985 563.928L142.638 563.959C142.532 563.97 142.434 563.984 142.344 563.999L142.092 564.048L141.873 564.108C141.804 564.13 141.74 564.154 141.677 564.18C140.697 564.586 139.918 565.364 139.512 566.345C139.487 566.407 139.463 566.472 139.441 566.54L139.381 566.759L139.331 567.011C139.316 567.102 139.303 567.199 139.291 567.306L139.26 567.652C139.256 567.715 139.252 567.78 139.248 567.848L139.229 568.292L139.213 569.105L139.208 570.542H152.541L152.54 569.866L152.53 568.757L152.505 567.926L152.474 567.448L152.446 567.185L152.412 566.959C152.406 566.924 152.4 566.89 152.393 566.857L152.349 566.671L152.297 566.503L152.237 566.345C151.831 565.364 151.052 564.586 150.072 564.18C150.01 564.154 149.945 564.13 149.876 564.108L149.657 564.048L149.405 563.999C149.315 563.984 149.217 563.97 149.111 563.959L148.764 563.928L148.355 563.905L147.875 563.889L146.997 563.877ZM145.875 546.542C149.188 546.542 151.875 549.228 151.875 552.542C151.875 555.856 149.188 558.542 145.875 558.542C142.561 558.542 139.875 555.856 139.875 552.542C139.875 549.228 142.561 546.542 145.875 546.542ZM138.968 547.949C139.389 548.553 139.241 549.384 138.637 549.805C137.748 550.426 137.208 551.437 137.208 552.542C137.208 553.725 137.828 554.8 138.824 555.4C139.455 555.78 139.658 556.599 139.278 557.23C138.898 557.861 138.079 558.064 137.448 557.684C135.659 556.606 134.541 554.67 134.541 552.542C134.541 550.556 135.514 548.732 137.112 547.618C137.716 547.197 138.547 547.345 138.968 547.949ZM154.637 547.618C156.235 548.732 157.208 550.556 157.208 552.542C157.208 554.528 156.235 556.352 154.637 557.466C154.033 557.887 153.202 557.739 152.781 557.135C152.36 556.531 152.508 555.7 153.112 555.279C154.002 554.658 154.541 553.646 154.541 552.542C154.541 551.437 154.002 550.426 153.112 549.805C152.508 549.384 152.36 548.553 152.781 547.949C153.202 547.345 154.033 547.197 154.637 547.618ZM145.875 549.209C144.034 549.209 142.541 550.701 142.541 552.542C142.541 554.383 144.034 555.875 145.875 555.875C147.716 555.875 149.208 554.383 149.208 552.542C149.208 550.701 147.716 549.209 145.875 549.209Z"
        fill="url(#paint3_linear_4575_34810)"
      />
      <path
        d="M146.997 563.877H144.755L143.876 563.889L143.395 563.904L142.986 563.927L142.638 563.958C142.532 563.97 142.434 563.983 142.344 563.998L142.092 564.047L141.873 564.108C141.804 564.129 141.74 564.153 141.677 564.179C140.697 564.585 139.918 565.364 139.513 566.344C139.487 566.406 139.463 566.471 139.441 566.54L139.381 566.759L139.331 567.01C139.316 567.101 139.303 567.199 139.291 567.305L139.261 567.652C139.256 567.714 139.252 567.78 139.248 567.848L139.229 568.292L139.213 569.104L139.208 570.541H152.541L152.54 569.865L152.53 568.757L152.505 567.925L152.474 567.447L152.446 567.185L152.412 566.958C152.406 566.923 152.4 566.889 152.393 566.856L152.349 566.67L152.297 566.502L152.237 566.344C151.831 565.364 151.052 564.585 150.072 564.179C150.01 564.153 149.945 564.129 149.876 564.108L149.657 564.047L149.406 563.998C149.315 563.983 149.217 563.97 149.111 563.958L148.764 563.927L148.355 563.904L147.875 563.889L146.997 563.877Z"
        fill="#E7EEFE"
      />
      <path
        d="M145.875 549.208C144.034 549.208 142.541 550.7 142.541 552.541C142.541 554.382 144.034 555.875 145.875 555.875C147.716 555.875 149.208 554.382 149.208 552.541C149.208 550.7 147.716 549.208 145.875 549.208Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter4_dd_4575_34810)">
        <rect
          x="375"
          y="490"
          width="83.8888"
          height="83.887"
          rx="16.7774"
          fill="white"
        />
        <rect
          x="373.684"
          y="488.684"
          width="86.5206"
          height="86.5188"
          rx="18.0933"
          stroke="#B2C9FF"
          stroke-width="2.63181"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M416.254 512.887C416.575 512.793 416.916 512.793 417.237 512.887L433.021 517.497C433.769 517.716 434.283 518.402 434.283 519.182V528.637C434.283 539.33 427.44 548.824 417.295 552.204C416.935 552.324 416.546 552.324 416.186 552.204C406.038 548.824 399.192 539.328 399.192 528.632V519.182C399.192 518.402 399.707 517.716 400.455 517.497L416.254 512.887ZM402.701 520.497V528.632C402.701 537.621 408.332 545.623 416.74 548.682C425.146 545.623 430.774 537.623 430.774 528.637V520.497L416.745 516.399L402.701 520.497Z"
        fill="url(#paint4_linear_4575_34810)"
      />
      <path
        d="M402.702 528.633V520.498L416.746 516.399L430.775 520.498V528.637C430.775 537.624 425.147 545.624 416.741 548.682C408.332 545.624 402.702 537.622 402.702 528.633Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter5_dd_4575_34810)">
        <path
          d="M178.543 281.125C183.451 272.625 195.719 272.625 200.626 281.125L225.815 324.753C230.722 333.252 224.588 343.877 214.773 343.877H164.396C154.581 343.877 148.447 333.252 153.355 324.753L178.543 281.125Z"
          fill="white"
        />
        <path
          d="M201.492 280.625C196.2 271.458 182.969 271.458 177.677 280.625L152.489 324.253C147.196 333.419 153.812 344.877 164.396 344.877H214.773C225.358 344.877 231.973 333.419 226.681 324.253L201.492 280.625Z"
          stroke="#B2C9FF"
          stroke-width="2"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M202.183 303.736C202.788 303.873 203.218 304.411 203.218 305.031V323.625C203.218 324.358 202.624 324.953 201.89 324.953H183.297C182.836 324.953 182.409 324.714 182.167 324.323C181.925 323.931 181.903 323.442 182.109 323.031L187.421 312.406C187.607 312.035 187.955 311.772 188.362 311.695C188.769 311.618 189.189 311.735 189.498 312.013L194.815 316.799L200.691 304.46C200.958 303.9 201.577 303.599 202.183 303.736ZM177.984 303.703C178.718 303.703 179.312 304.298 179.312 305.031V327.609H201.89C202.624 327.609 203.218 328.204 203.218 328.937C203.218 329.671 202.624 330.265 201.89 330.265H177.984C177.251 330.265 176.656 329.671 176.656 328.937V305.031C176.656 304.298 177.251 303.703 177.984 303.703ZM200.562 310.909L196.449 319.547C196.268 319.926 195.92 320.197 195.509 320.279C195.098 320.361 194.673 320.244 194.361 319.964L189.017 315.154L185.446 322.297H200.562V310.909Z"
        fill="url(#paint5_linear_4575_34810)"
      />
      <path
        d="M196.448 319.548L200.562 310.91V322.297H185.445L189.017 315.155L194.361 319.964C194.672 320.245 195.098 320.361 195.509 320.28C195.92 320.198 196.268 319.926 196.448 319.548Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter6_dd_4575_34810)">
        <rect
          x="28"
          y="429"
          width="63.7486"
          height="63.7486"
          rx="12"
          fill="white"
        />
        <rect
          x="27"
          y="428"
          width="65.7486"
          height="65.7486"
          rx="13"
          stroke="#B2C9FF"
          stroke-width="2"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M59.2138 446.589C59.6819 446.248 60.3171 446.248 60.7853 446.589L63.9352 448.887L67.8341 448.879C68.4136 448.878 68.9275 449.252 69.1055 449.803L70.3033 453.514L73.4619 455.799C73.9314 456.139 74.1277 456.743 73.9476 457.294L72.7357 461L73.9476 464.705C74.1277 465.256 73.9314 465.86 73.4619 466.2L70.3033 468.486L69.1055 472.196C68.9275 472.748 68.4136 473.121 67.8341 473.12L63.9352 473.112L60.7853 475.41C60.3171 475.752 59.6819 475.752 59.2138 475.41L56.0638 473.112L52.1649 473.12C51.5854 473.121 51.0716 472.748 50.8935 472.196L49.6958 468.486L46.5371 466.2C46.0676 465.86 45.8714 465.256 46.0515 464.705L47.2634 461L46.0515 457.294C45.8714 456.743 46.0676 456.139 46.5371 455.799L49.6958 453.514L50.8935 449.803C51.0716 449.252 51.5854 448.878 52.1649 448.879L56.0638 448.887L59.2138 446.589ZM59.9995 449.317L57.2831 451.298C57.0542 451.465 56.7781 451.555 56.4948 451.554L53.1325 451.548L52.0995 454.748C52.0125 455.017 51.8418 455.252 51.6123 455.418L48.8884 457.389L49.9335 460.585C50.0215 460.855 50.0215 461.145 49.9335 461.414L48.8884 464.61L51.6123 466.581C51.8418 466.747 52.0125 466.982 52.0995 467.252L53.1325 470.451L56.4948 470.445C56.7781 470.444 57.0542 470.534 57.2831 470.701L59.9995 472.683L62.716 470.701C62.9448 470.534 63.221 470.444 63.5043 470.445L66.8666 470.451L67.8995 467.252C67.9866 466.982 68.1572 466.747 68.3867 466.581L71.1107 464.61L70.0656 461.414C69.9775 461.145 69.9775 460.855 70.0656 460.585L71.1107 457.389L68.3867 455.418C68.1572 455.252 67.9866 455.017 67.8995 454.748L66.8666 451.548L63.5043 451.554C63.221 451.555 62.9448 451.465 62.716 451.298L59.9995 449.317ZM66.2757 456.724C66.7964 457.244 66.7964 458.088 66.2757 458.609L59.609 465.276C59.0883 465.797 58.2441 465.797 57.7234 465.276L54.3901 461.942C53.8694 461.422 53.8694 460.578 54.3901 460.057C54.9108 459.536 55.755 459.536 56.2757 460.057L58.6662 462.447L64.3901 456.724C64.9108 456.203 65.755 456.203 66.2757 456.724Z"
        fill="url(#paint6_linear_4575_34810)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M57.2834 451.299L59.9998 449.317L62.7163 451.299C62.9451 451.466 63.2213 451.556 63.5046 451.555L66.8669 451.549L67.8998 454.748C67.9869 455.018 68.1575 455.253 68.387 455.419L71.111 457.39L70.0659 460.586C69.9778 460.855 69.9778 461.146 70.0659 461.415L71.111 464.611L68.387 466.582C68.1575 466.748 67.9869 466.983 67.8998 467.252L66.8669 470.452L63.5045 470.446C63.2212 470.445 62.9451 470.535 62.7163 470.702L59.9998 472.683L57.2834 470.702C57.0545 470.535 56.7784 470.445 56.4951 470.446L53.1328 470.452L52.0998 467.252C52.0128 466.983 51.8421 466.748 51.6126 466.582L48.8887 464.611L49.9338 461.415C50.0218 461.146 50.0218 460.855 49.9338 460.586L48.8887 457.39L51.6126 455.419C51.8421 455.253 52.0128 455.018 52.0998 454.748L53.1328 451.549L56.4951 451.555C56.7784 451.556 57.0545 451.466 57.2834 451.299ZM66.276 456.724C66.7967 457.245 66.7967 458.089 66.276 458.61L59.6093 465.276C59.0886 465.797 58.2444 465.797 57.7237 465.276L54.3903 461.943C53.8696 461.422 53.8696 460.578 54.3903 460.058C54.911 459.537 55.7553 459.537 56.276 460.058L58.6665 462.448L64.3903 456.724C64.911 456.203 65.7553 456.203 66.276 456.724Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter7_d_4575_34810)">
        <rect
          x="40"
          y="288"
          width="35.3551"
          height="35.3551"
          rx="6.65962"
          transform="rotate(-45 40 288)"
          fill="#B2C9FF"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M59 279C57.3431 279 56 280.343 56 282C56 283.657 57.3431 285 59 285H71C72.6569 285 74 283.657 74 282C74 280.343 72.6569 279 71 279H59ZM54 282C54 279.239 56.2386 277 59 277H71C73.7614 277 76 279.239 76 282C76 284.761 73.7614 287 71 287H59C56.2386 287 54 284.761 54 282ZM69 282C69 280.895 69.8954 280 71 280C72.1046 280 73 280.895 73 282C73 283.105 72.1046 284 71 284C69.8954 284 69 283.105 69 282ZM59 291C57.3431 291 56 292.343 56 294C56 295.657 57.3431 297 59 297H71C72.6569 297 74 295.657 74 294C74 292.343 72.6569 291 71 291H59ZM54 294C54 291.239 56.2386 289 59 289H71C73.7614 289 76 291.239 76 294C76 296.761 73.7614 299 71 299H59C56.2386 299 54 296.761 54 294ZM57 294C57 292.895 57.8954 292 59 292C60.1046 292 61 292.895 61 294C61 295.105 60.1046 296 59 296C57.8954 296 57 295.105 57 294Z"
        fill="url(#paint7_linear_4575_34810)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56 282C56 280.343 57.3431 279 59 279H71C72.6569 279 74 280.343 74 282C74 283.657 72.6569 285 71 285H59C57.3431 285 56 283.657 56 282ZM69 282C69 280.895 69.8954 280 71 280C72.1046 280 73 280.895 73 282C73 283.105 72.1046 284 71 284C69.8954 284 69 283.105 69 282Z"
        fill="#E7EEFE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M56 294C56 292.343 57.3431 291 59 291H71C72.6569 291 74 292.343 74 294C74 295.657 72.6569 297 71 297H59C57.3431 297 56 295.657 56 294ZM57 294C57 292.895 57.8954 292 59 292C60.1046 292 61 292.895 61 294C61 295.105 60.1046 296 59 296C57.8954 296 57 295.105 57 294Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter8_d_4575_34810)">
        <rect
          x="349"
          y="321"
          width="41"
          height="42"
          rx="20.5"
          transform="rotate(-90 349 321)"
          fill="#B2C9FF"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M359.562 292.501C359.562 291.949 360.01 291.501 360.563 291.501H380.563C381.115 291.501 381.563 291.949 381.563 292.501V305.501C381.563 306.053 381.115 306.501 380.563 306.501H371.563V308.501H376.563C377.115 308.501 377.563 308.949 377.563 309.501C377.563 310.053 377.115 310.501 376.563 310.501H364.563C364.01 310.501 363.563 310.053 363.563 309.501C363.563 308.949 364.01 308.501 364.563 308.501H369.563V306.501H360.563C360.01 306.501 359.562 306.053 359.562 305.501V292.501ZM379.563 304.501V293.501H361.563V304.501H379.563ZM374.563 295.001C375.115 295.001 375.563 295.449 375.563 296.001V302.001C375.563 302.553 375.115 303.001 374.563 303.001C374.01 303.001 373.563 302.553 373.563 302.001V296.001C373.563 295.449 374.01 295.001 374.563 295.001ZM370.563 297.001C371.115 297.001 371.563 297.449 371.563 298.001V302.001C371.563 302.553 371.115 303.001 370.563 303.001C370.01 303.001 369.563 302.553 369.563 302.001V298.001C369.563 297.449 370.01 297.001 370.563 297.001ZM366.563 299.001C367.115 299.001 367.563 299.449 367.563 300.001V302.001C367.563 302.553 367.115 303.001 366.563 303.001C366.01 303.001 365.563 302.553 365.563 302.001V300.001C365.563 299.449 366.01 299.001 366.563 299.001Z"
        fill="url(#paint8_linear_4575_34810)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M379.562 293.5V304.5H361.562V293.5H379.562ZM374.562 295C375.115 295 375.562 295.448 375.562 296V302C375.562 302.552 375.115 303 374.562 303C374.01 303 373.562 302.552 373.562 302V296C373.562 295.448 374.01 295 374.562 295ZM370.562 297C371.115 297 371.562 297.448 371.562 298V302C371.562 302.552 371.115 303 370.562 303C370.01 303 369.562 302.552 369.562 302V298C369.562 297.448 370.01 297 370.562 297ZM366.562 299C367.115 299 367.562 299.448 367.562 300V302C367.562 302.552 367.115 303 366.562 303C366.01 303 365.562 302.552 365.562 302V300C365.562 299.448 366.01 299 366.562 299Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter9_dd_4575_34810)">
        <rect
          x="49"
          y="115"
          width="83.887"
          height="83.887"
          rx="16.7774"
          fill="white"
        />
        <rect
          x="47.6841"
          y="113.684"
          width="86.5188"
          height="86.5188"
          rx="18.0933"
          stroke="#B2C9FF"
          stroke-width="2.63181"
        />
      </g>
      <path
        d="M91.1089 167.471C92.0086 167.471 92.7502 168.148 92.8516 169.021L92.8634 169.225V174.489C92.8634 175.458 92.0779 176.243 91.1089 176.243C90.2091 176.243 89.4675 175.566 89.3661 174.694L89.3543 174.489V169.225C89.3543 168.256 90.1398 167.471 91.1089 167.471ZM84.0907 169.225C84.9905 169.225 85.7321 169.903 85.8334 170.775L85.8452 170.98V172.734C85.8452 173.703 85.0597 174.489 84.0907 174.489C83.1909 174.489 82.4493 173.812 82.348 172.939L82.3362 172.734V170.98C82.3362 170.011 83.1217 169.225 84.0907 169.225ZM98.127 169.225C99.0268 169.225 99.7684 169.903 99.8697 170.775L99.8815 170.98V172.734C99.8815 173.703 99.096 174.489 98.127 174.489C97.2272 174.489 96.4856 173.812 96.3843 172.939L96.3725 172.734V170.98C96.3725 170.011 97.158 169.225 98.127 169.225ZM88.6757 138.911C90.1491 137.929 92.0685 137.929 93.542 138.911L94.7964 139.748C99.7807 143.071 102.917 148.502 103.341 154.426L108.162 159.425C108.425 159.698 108.592 160.046 108.64 160.418L108.654 160.643V164.839C108.654 165.739 107.977 166.48 107.104 166.582L106.9 166.594H75.318C74.4182 166.594 73.6766 165.916 73.5753 165.044L73.5635 164.839V160.643C73.5635 160.265 73.686 159.898 73.9095 159.597L74.0555 159.425L78.8764 154.426C79.3005 148.502 82.437 143.071 87.4213 139.748L88.6757 138.911ZM78.8271 159.533L77.0726 161.351V163.084L78.8271 163.084V159.533ZM91.5956 141.831C91.3008 141.635 90.9169 141.635 90.6222 141.831L89.3678 142.667C84.9748 145.596 82.3362 150.527 82.3362 155.806V163.084H99.8815V155.806C99.8815 150.703 97.4159 145.925 93.2833 142.967L92.8498 142.667L91.5956 141.831ZM103.391 159.535V163.084L105.145 163.084V161.353L103.391 159.535ZM91.1089 146.416C94.9849 146.416 98.127 149.558 98.127 153.434C98.127 157.311 94.9849 160.453 91.1089 160.453C87.2328 160.453 84.0907 157.311 84.0907 153.434C84.0907 149.558 87.2328 146.416 91.1089 146.416ZM91.1089 149.925C89.1708 149.925 87.5998 151.496 87.5998 153.434C87.5998 155.373 89.1708 156.944 91.1089 156.944C93.0469 156.944 94.6179 155.373 94.6179 153.434C94.6179 151.496 93.0469 149.925 91.1089 149.925Z"
        fill="url(#paint9_linear_4575_34810)"
      />
      <path
        d="M91.1087 149.926C89.1707 149.926 87.5996 151.497 87.5996 153.435C87.5996 155.373 89.1706 156.944 91.1087 156.944C93.0468 156.944 94.6178 155.373 94.6178 153.435C94.6178 151.497 93.0467 149.926 91.1087 149.926Z"
        fill="#E7EEFE"
      />
      <g filter="url(#filter10_d_4575_34810)">
        <rect
          x="251"
          y="214.355"
          width="35.3551"
          height="35.3551"
          rx="6.65962"
          transform="rotate(-90 251 214.355)"
          fill="#B2C9FF"
        />
        <path
          d="M266.5 197.355C266.5 197.908 266.052 198.355 265.5 198.355C264.948 198.355 264.5 197.908 264.5 197.355C264.5 196.803 264.948 196.355 265.5 196.355C266.052 196.355 266.5 196.803 266.5 197.355Z"
          fill="url(#paint10_linear_4575_34810)"
        />
        <path
          d="M272.5 198.355C273.052 198.355 273.5 197.908 273.5 197.355C273.5 196.803 273.052 196.355 272.5 196.355C271.948 196.355 271.5 196.803 271.5 197.355C271.5 197.908 271.948 198.355 272.5 198.355Z"
          fill="url(#paint11_linear_4575_34810)"
        />
        <path
          d="M266 201.355C266 200.803 266.448 200.355 267 200.355H271C271.552 200.355 272 200.803 272 201.355C272 201.908 271.552 202.355 271 202.355H267C266.448 202.355 266 201.908 266 201.355Z"
          fill="url(#paint12_linear_4575_34810)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M269 186.355C267.895 186.355 267 187.251 267 188.355C267 189.096 267.402 189.742 268 190.088V192.355H262.5C261.395 192.355 260.5 193.251 260.5 194.355V204.355C260.5 205.46 261.395 206.355 262.5 206.355H275.5C276.605 206.355 277.5 205.46 277.5 204.355V194.355C277.5 193.251 276.605 192.355 275.5 192.355H270V190.088C270.598 189.742 271 189.096 271 188.355C271 187.251 270.105 186.355 269 186.355ZM262.5 194.355H275.5V204.355H262.5V194.355Z"
          fill="url(#paint13_linear_4575_34810)"
        />
        <path
          d="M260 197.355C260 196.803 259.552 196.355 259 196.355C258.448 196.355 258 196.803 258 197.355V201.355C258 201.908 258.448 202.355 259 202.355C259.552 202.355 260 201.908 260 201.355V197.355Z"
          fill="url(#paint14_linear_4575_34810)"
        />
        <path
          d="M279 196.355C279.552 196.355 280 196.803 280 197.355V201.355C280 201.908 279.552 202.355 279 202.355C278.448 202.355 278 201.908 278 201.355V197.355C278 196.803 278.448 196.355 279 196.355Z"
          fill="url(#paint15_linear_4575_34810)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M275.5 204.355V194.355H262.5V204.355H275.5ZM266.5 197.355C266.5 197.908 266.052 198.355 265.5 198.355C264.948 198.355 264.5 197.908 264.5 197.355C264.5 196.803 264.948 196.355 265.5 196.355C266.052 196.355 266.5 196.803 266.5 197.355ZM272.5 198.355C273.052 198.355 273.5 197.908 273.5 197.355C273.5 196.803 273.052 196.355 272.5 196.355C271.948 196.355 271.5 196.803 271.5 197.355C271.5 197.908 271.948 198.355 272.5 198.355ZM266 201.355C266 200.803 266.448 200.355 267 200.355H271C271.552 200.355 272 200.803 272 201.355C272 201.908 271.552 202.355 271 202.355H267C266.448 202.355 266 201.908 266 201.355Z"
          fill="#E7EEFE"
        />
      </g>
      <g filter="url(#filter11_d_4575_34810)">
        <rect
          x="281"
          y="548.355"
          width="35.3551"
          height="35.3551"
          rx="6.65962"
          transform="rotate(-90 281 548.355)"
          fill="#B2C9FF"
        />
        <path
          d="M295.688 528.093C295.688 528.719 295.184 529.227 294.562 529.227C293.941 529.227 293.438 528.719 293.438 528.093C293.438 527.467 293.941 526.96 294.562 526.96C295.184 526.96 295.688 527.467 295.688 528.093Z"
          fill="url(#paint16_linear_4575_34810)"
        />
        <path
          d="M300.188 528.093C300.188 528.719 299.684 529.227 299.062 529.227C298.441 529.227 297.938 528.719 297.938 528.093C297.938 527.467 298.441 526.96 299.062 526.96C299.684 526.96 300.188 527.467 300.188 528.093Z"
          fill="url(#paint17_linear_4575_34810)"
        />
        <path
          d="M300.625 533.543C300.625 534.013 301.003 534.393 301.469 534.393C301.935 534.393 302.312 534.013 302.312 533.543C302.312 533.074 301.935 532.693 301.469 532.693C301.003 532.693 300.625 533.074 300.625 533.543Z"
          fill="url(#paint18_linear_4575_34810)"
        />
        <path
          d="M304 533.543C304 534.013 304.378 534.393 304.844 534.393C305.31 534.393 305.688 534.013 305.688 533.543C305.688 533.074 305.31 532.693 304.844 532.693C304.378 532.693 304 533.074 304 533.543Z"
          fill="url(#paint19_linear_4575_34810)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M288.5 529.993C288.5 525.023 292.529 520.993 297.5 520.993C302.268 520.993 306.17 524.701 306.48 529.392C308.29 530.486 309.5 532.473 309.5 534.743C309.5 535.579 309.335 536.378 309.036 537.109L309.487 539.83C309.548 540.199 309.397 540.572 309.097 540.795C308.797 541.019 308.397 541.056 308.061 540.892L306.458 540.108C305.52 540.67 304.421 540.993 303.25 540.993C301.413 540.993 299.761 540.2 298.617 538.938C297.323 539.092 295.986 538.953 294.616 538.544L291.4 539.925C291.064 540.069 290.676 540.019 290.388 539.793C290.1 539.567 289.959 539.203 290.019 538.842L290.541 535.701C289.266 534.148 288.5 532.159 288.5 529.993ZM297.419 536.997C297.148 536.298 297 535.538 297 534.743C297 531.291 299.798 528.493 303.25 528.493C303.629 528.493 304 528.527 304.36 528.591C303.71 525.397 300.886 522.993 297.5 522.993C293.634 522.993 290.5 526.127 290.5 529.993C290.5 531.818 291.197 533.478 292.341 534.725C292.549 534.951 292.641 535.261 292.591 535.565L292.292 537.365L294.168 536.559C294.393 536.463 294.646 536.452 294.878 536.529C295.773 536.827 296.618 536.979 297.419 536.997ZM299 534.743C299 532.396 300.903 530.493 303.25 530.493C305.597 530.493 307.5 532.396 307.5 534.743C307.5 535.388 307.357 535.997 307.102 536.542C307.054 536.64 307.022 536.746 307.008 536.857C306.996 536.957 306.999 537.057 307.017 537.155L307.197 538.243L306.839 538.068C306.667 537.98 306.473 537.944 306.282 537.963C306.147 537.976 306.013 538.017 305.89 538.087C305.847 538.11 305.807 538.137 305.768 538.167C305.063 538.687 304.194 538.993 303.25 538.993C300.903 538.993 299 537.09 299 534.743Z"
          fill="url(#paint20_linear_4575_34810)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M297 534.743C297 535.538 297.148 536.298 297.419 536.997C296.618 536.979 295.773 536.827 294.878 536.529C294.646 536.452 294.393 536.463 294.168 536.559L292.292 537.365L292.591 535.565C292.641 535.261 292.549 534.951 292.341 534.725C291.197 533.478 290.5 531.818 290.5 529.993C290.5 526.127 293.634 522.993 297.5 522.993C300.886 522.993 303.71 525.397 304.36 528.591C304 528.527 303.629 528.493 303.25 528.493C299.798 528.493 297 531.291 297 534.743ZM295.688 528.093C295.688 528.719 295.184 529.227 294.562 529.227C293.941 529.227 293.438 528.719 293.438 528.093C293.438 527.467 293.941 526.96 294.562 526.96C295.184 526.96 295.688 527.467 295.688 528.093ZM300.188 528.093C300.188 528.719 299.684 529.227 299.062 529.227C298.441 529.227 297.938 528.719 297.938 528.093C297.938 527.467 298.441 526.96 299.062 526.96C299.684 526.96 300.188 527.467 300.188 528.093Z"
          fill="#E7EEFE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M303.25 530.493C300.903 530.493 299 532.396 299 534.743C299 537.09 300.903 538.993 303.25 538.993C304.194 538.993 305.063 538.687 305.768 538.167C305.807 538.137 305.847 538.11 305.89 538.087C306.013 538.017 306.147 537.976 306.282 537.963C306.473 537.944 306.667 537.98 306.839 538.068L307.197 538.243L307.017 537.155C306.999 537.057 306.996 536.957 307.008 536.857C307.022 536.746 307.054 536.64 307.102 536.542C307.357 535.997 307.5 535.388 307.5 534.743C307.5 532.396 305.597 530.493 303.25 530.493ZM300.625 533.543C300.625 534.013 301.003 534.393 301.469 534.393C301.935 534.393 302.312 534.013 302.312 533.543C302.312 533.074 301.935 532.693 301.469 532.693C301.003 532.693 300.625 533.074 300.625 533.543ZM304 533.543C304 534.013 304.378 534.393 304.844 534.393C305.31 534.393 305.688 534.013 305.688 533.543C305.688 533.074 305.31 532.693 304.844 532.693C304.378 532.693 304 533.074 304 533.543Z"
          fill="#E7EEFE"
        />
      </g>
      <g filter="url(#filter12_d_4575_34810)">
        <rect
          x="189"
          y="465"
          width="35.3551"
          height="35.3551"
          rx="6.65962"
          transform="rotate(-135 189 465)"
          fill="#B2C9FF"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M181.821 431.814C181.821 431.262 182.269 430.814 182.821 430.814H195.821C196.374 430.814 196.821 431.262 196.821 431.814V432.814H199.321C199.874 432.814 200.321 433.262 200.321 433.814V446.814C200.321 447.367 199.874 447.814 199.321 447.814H196.821V448.814C196.821 449.367 196.374 449.814 195.821 449.814H182.821C182.269 449.814 181.821 449.367 181.821 448.814V447.814H179.321C178.769 447.814 178.321 447.367 178.321 446.814V433.814C178.321 433.262 178.769 432.814 179.321 432.814H181.821V431.814ZM183.821 447.814H194.821V432.814H183.821V447.814ZM181.821 434.814H180.321V445.814H181.821V434.814ZM196.821 445.814H198.321V434.814H196.821V445.814ZM187.849 437.433C188.175 437.259 188.569 437.278 188.876 437.482L191.876 439.482C192.154 439.668 192.321 439.98 192.321 440.314C192.321 440.649 192.154 440.961 191.876 441.146L188.876 443.146C188.569 443.351 188.175 443.37 187.849 443.196C187.524 443.022 187.321 442.683 187.321 442.314V438.314C187.321 437.946 187.524 437.607 187.849 437.433ZM189.321 440.183V440.446L189.519 440.314L189.321 440.183Z"
          fill="url(#paint21_linear_4575_34810)"
        />
        <path
          d="M180.321 434.814H181.821V445.814H180.321V434.814Z"
          fill="#E7EEFE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M194.821 447.814H183.821V432.814H194.821V447.814ZM187.849 437.433C188.175 437.259 188.569 437.278 188.876 437.482L191.876 439.482C192.154 439.668 192.321 439.98 192.321 440.314C192.321 440.649 192.154 440.961 191.876 441.146L188.876 443.146C188.569 443.351 188.175 443.37 187.849 443.196C187.524 443.022 187.321 442.683 187.321 442.314V438.314C187.321 437.946 187.524 437.607 187.849 437.433Z"
          fill="#E7EEFE"
        />
        <path
          d="M198.321 445.814H196.821V434.814H198.321V445.814Z"
          fill="#E7EEFE"
        />
        <path
          d="M189.321 440.446V440.183L189.519 440.314L189.321 440.446Z"
          fill="#E7EEFE"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_4575_34810"
          x="218.782"
          y="0.969241"
          width="134.591"
          height="137.904"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.18743" />
          <feGaussianBlur stdDeviation="12.7497" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.155312 0 0 0 0 0.523158 0 0 0 0 0.8875 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_4575_34810"
            result="effect2_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_4575_34810"
          x="328.689"
          y="89.7851"
          width="172.278"
          height="167.698"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.19435" />
          <feGaussianBlur stdDeviation="16.7774" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.155312 0 0 0 0 0.523158 0 0 0 0 0.8875 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10.5272" />
          <feGaussianBlur stdDeviation="15.7908" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_4575_34810"
            result="effect2_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_dd_4575_34810"
          x="253.782"
          y="330.969"
          width="134.591"
          height="137.904"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.18743" />
          <feGaussianBlur stdDeviation="12.7497" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.155312 0 0 0 0 0.523158 0 0 0 0 0.8875 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_4575_34810"
            result="effect2_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_4575_34810"
          x="88"
          y="510"
          width="115.749"
          height="115.749"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_dd_4575_34810"
          x="338.813"
          y="458.008"
          width="156.262"
          height="160.62"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.19435" />
          <feGaussianBlur stdDeviation="16.7774" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.155312 0 0 0 0 0.523158 0 0 0 0 0.8875 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10.5272" />
          <feGaussianBlur stdDeviation="15.7908" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_4575_34810"
            result="effect2_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter5_dd_4575_34810"
          x="124.125"
          y="250.438"
          width="130.92"
          height="127.439"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.18743" />
          <feGaussianBlur stdDeviation="12.7497" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.155312 0 0 0 0 0.523158 0 0 0 0 0.8875 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_4575_34810"
            result="effect2_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_dd_4575_34810"
          x="0.500561"
          y="404.688"
          width="118.748"
          height="122.061"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3.18743" />
          <feGaussianBlur stdDeviation="12.7497" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.155312 0 0 0 0 0.523158 0 0 0 0 0.8875 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_4575_34810"
            result="effect2_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_4575_34810"
          x="18.7588"
          y="249.759"
          width="92.4824"
          height="92.4824"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_4575_34810"
          x="325"
          y="264"
          width="90"
          height="89"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_dd_4575_34810"
          x="12.8134"
          y="83.0077"
          width="156.26"
          height="160.62"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.19435" />
          <feGaussianBlur stdDeviation="16.7774" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.155312 0 0 0 0 0.523158 0 0 0 0 0.8875 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10.5272" />
          <feGaussianBlur stdDeviation="15.7908" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_4575_34810"
            result="effect2_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d_4575_34810"
          x="227"
          y="163"
          width="83.3555"
          height="83.3555"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_d_4575_34810"
          x="257"
          y="497"
          width="83.3555"
          height="83.3555"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <filter
          id="filter12_d_4575_34810"
          x="142.759"
          y="401.759"
          width="92.4824"
          height="92.4824"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0248281 0 0 0 0 0.0164062 0 0 0 0 0.4375 0 0 0 0.48 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4575_34810"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4575_34810"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_4575_34810"
          x1="271.585"
          y1="53.4688"
          x2="296.795"
          y2="82.4106"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4575_34810"
          x1="392.906"
          y1="157.004"
          x2="431.506"
          y2="195.604"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4575_34810"
          x1="306.333"
          y1="383.335"
          x2="331.397"
          y2="412.356"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4575_34810"
          x1="131.208"
          y1="546.542"
          x2="157.754"
          y2="575.742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4575_34810"
          x1="399.192"
          y1="512.816"
          x2="438.398"
          y2="547.665"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4575_34810"
          x1="176.656"
          y1="303.703"
          x2="203.218"
          y2="330.265"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4575_34810"
          x1="45.9854"
          y1="446.333"
          x2="75.2883"
          y2="474.332"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4575_34810"
          x1="54"
          y1="277"
          x2="76"
          y2="299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_4575_34810"
          x1="359.562"
          y1="291.501"
          x2="378.36"
          y2="313.267"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_4575_34810"
          x1="73.5635"
          y1="138.175"
          x2="111.506"
          y2="173.149"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_4575_34810"
          x1="258"
          y1="186.355"
          x2="277.91"
          y2="208.256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_4575_34810"
          x1="258"
          y1="186.355"
          x2="277.91"
          y2="208.256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_4575_34810"
          x1="258"
          y1="186.355"
          x2="277.91"
          y2="208.256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_4575_34810"
          x1="258"
          y1="186.355"
          x2="277.91"
          y2="208.256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_4575_34810"
          x1="258"
          y1="186.355"
          x2="277.91"
          y2="208.256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_4575_34810"
          x1="258"
          y1="186.355"
          x2="277.91"
          y2="208.256"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_4575_34810"
          x1="288.5"
          y1="520.993"
          x2="308.476"
          y2="541.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_4575_34810"
          x1="288.5"
          y1="520.993"
          x2="308.476"
          y2="541.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_4575_34810"
          x1="288.5"
          y1="520.993"
          x2="308.476"
          y2="541.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_4575_34810"
          x1="288.5"
          y1="520.993"
          x2="308.476"
          y2="541.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_4575_34810"
          x1="288.5"
          y1="520.993"
          x2="308.476"
          y2="541.968"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_4575_34810"
          x1="178.321"
          y1="430.814"
          x2="197.119"
          y2="452.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
      </defs>
    </svg>
  );
};
